const TableTestIdsScope = {
  TABLE: 'table',
};

export const TableTestIds = {
  // FilterBaseCDS
  DATE_TIMEZONE_SWITCH: `${TableTestIdsScope.TABLE}.date-timezone-switch`,
  FILTER_BASE_INPUT: `${TableTestIdsScope.TABLE}.filter-base-input`,
  FILTER_BASE_DATE_RANGE: `${TableTestIdsScope.TABLE}.filter-base-date-range-content`,
  FILTER_MENU: `${TableTestIdsScope.TABLE}.filter-menu`,
  MENU_CONTROLS_BUTTON: `${TableTestIdsScope.TABLE}.menu-controls-button`,
  MULTI_SELECT_MENU: `${TableTestIdsScope.TABLE}.multi-select-menu`,
};
